module.exports = ".btn-default, .btn-default:focus {\n  border-color: #d9d9d9; }\n\n.table-responsive .table tr:last-child td {\n  border-bottom: none; }\n\n.list-item-wrapper ul {\n  list-style: none;\n  padding-left: 0;\n  margin: 0; }\n\n.list-item-wrapper ul li:not(:last-child) {\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08); }\n"


//////////////////
// WEBPACK FOOTER
// ./libs/chassis-core/src/app/dashboards/components/list-widget/list-widget.component.scss
// module id = ./libs/chassis-core/src/app/dashboards/components/list-widget/list-widget.component.scss
// module chunks = main